module.exports = __webpack_public_path__ + "static/img/anli1.7ccf3a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli1.jpg
// module id = MEZU
// module chunks = 1